<template>
  <div v-if="permission.access">
    <div class="row">
      <div class="col-md-8">
        <b-card no-body>
          <div class="mx-2 mb-2 mt-2">
            <b-row>
              <b-col
                xl="3"
                class="mb-1"
                v-for="(life, index) in lifes.data"
                :key="index"
                v-if="lifes.data.length"
              >
                <div class="div position-relative">
                  <img
                    :src="life.image"
                    style="border-radius: 10px"
                    width="100%"
                    alt="d"
                  />
                  <button
                    v-if="permission.delete"
                    class="btn-sm position-absolute"
                    style="
                      z-index: 99;
                      right: 0;
                      color: red;
                      border: none;
                      background: transparent;
                    "
                    @click="Delete(life.id)"
                  >
                    <feather-icon icon="TrashIcon" size="16" />
                  </button>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                cols="12"
                md="12"
                class="d-flex align-items-center justify-content-center justify-content-sm-start"
              >
                <div></div>
              </b-col>
            </b-row>
          </div>
        </b-card>
      </div>
      <div class="col-md-4" v-if="permission.create || form.id != ''">
        <b-card
          title="
             Add Life At Cit
           "
        >
          <b-card-text>
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
              enctype="multipart/form-data"
            >
              <div class="row">
                <div class="col-md-12">
                  <div class="border rounded p-2 mb-2">
                    <b-img
                      :src="image"
                      height="250"
                      width="430"
                      class="rounded mr-2 mb-1 mb-md-0"
                    />
                    <b-form-group>
                      <b-form-file
                        class="mt-1"
                        id="image"
                        accept=".jpg, .png, .gif"
                        @change="loadImage($event)"
                        placeholder="Select Image"
                        drop-placeholder="Drop file here..."
                      />
                    </b-form-group>
                  </div>
                </div>
              </div>
              <!-- submit buttons -->

              <b-button
                type="submit"
                class="float-right"
                variant="primary"
                @click="add"
              >
                Create
              </b-button>
              <b-button
                type="submit"
                class="float-right mx-1"
                variant="outline-primary"
                @click="Close"
              >
                Close
              </b-button>
            </b-form>
          </b-card-text>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BTabs,
  BTab,
  BCard,
  BMediaBody,
  BMediaAside,
  BMedia,
  BFormFile,
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BFormTextarea,
} from "bootstrap-vue";
import vSelect from "vue-select";
import _ from "lodash";

export default {
  data() {
    return {
      form: {
        _method: "POST",
        image: "",
      },
      image: this.$store.state.base_url + "images/course/default.png",
      lifes: {},
      permission: {
        access: false,
        create: false,
        delete: false,
      },
    };
  },
  mounted() {
    this.getResults();
    this.Permission();
  },
  methods: {
    getResults() {
      axios
        .get(`/app/life/cit`)
        .then((res) => {
          this.lifes = res.data;
        })
        .catch((e) => {
          this.e(e.response.data.message);
        });
    },

    loadImage(e) {
      this.form.image = e.target.files[0];
      let file = e.target.files[0];
      let reader = new FileReader();
      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    Close() {
      this.form.image = "";
      this.image = null;
      this.image = this.$store.state.base_url + "images/course/default.png";
    },

    add() {
      const fd = new FormData();
      if (this.form.image) {
        fd.append("image", this.form.image);
      }
      axios
        .post("/app/life/cit", fd)
        .then((res) => {
          this.getResults();
          this.Close();
          this.s(res.data.message);
        })
        .catch((e) => {
          if (e.response.status === 422) {
            if (e.response.data.errors.image)
              this.e(e.response.data.errors.image[0]);
          }
        });
    },

    async Delete(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't to delete it!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete("/app/life/cit/" + id)
            .then((response) => {
              this.s(response.data.message);
              this.getResults();
            })
            .catch((e) => {
              this.e(e.data.error);
            });
        }
      });
    },

    async Permission() {
      const permissions = await this.callApi("post", "/app/permission");
      permissions.data.permissions.forEach((permission) => {
        if (permission.slug == "life.at.cit.access") {
          this.permission.access = true;
        }

        if (permission.slug == "life.at.cit.create") {
          this.permission.create = true;
        }

        if (permission.slug == "life.at.cit.destroy") {
          this.permission.delete = true;
        }
      });
    },
  },
  components: {
    BCard,
    vSelect,
    BCardText,
    BLink,
    BTabs,
    BTab,
    BMedia,
    BFormFile,
    BFormTextarea,
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BMediaAside,
    BMediaBody,
  },
};
</script>
